import { allTrackers } from "app/services/track/track";

import createSignalsTrackingService from "./factory";

const signalsTrackingService = createSignalsTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default signalsTrackingService;
